import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { illustrationUrl } from '../illustrations';

/**
 * refresh-parent-portal-ui 0.1: a decorative Fluent Emoji Flat illustration
 * inside the cream circle. Purely decorative (alt=""), tiles carry text labels.
 */
@Component({
  selector: 'ui-illustration',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="ill" [class.bare]="bare()" aria-hidden="true">
      @if (url()) {
        <img [src]="url()" alt="" [style.width.px]="size()" [style.height.px]="size()" />
      } @else {
        <!-- 3.25 (U41): no drawing for this section — an emoji stands in (🏫). -->
        <span class="ill-emoji" [style.fontSize.px]="size() - 6">{{ name() }}</span>
      }
    </span>
  `,
  styles: [
    `
      .ill-emoji {
        line-height: 1;
      }
      .ill.bare {
        padding: 0;
        background: none;
      }
      .ill {
        display: grid;
        place-items: center;
        background: var(--gp-surface);
        border-radius: 50%;
        padding: 10px;
        box-sizing: content-box;
        flex: 0 0 auto;
      }
    `,
  ],
})
export class UiIllustrationComponent {
  readonly name = input.required<string>();
  readonly size = input(56);
  /** 3.40: no padding/background — the badge draws its own ring. */
  readonly bare = input(false);

  readonly url = computed(() => {
    const src = illustrationUrl(this.name());
    return src ? 'data:image/svg+xml;utf8,' + encodeURIComponent(src) : '';
  });
}